/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import Chevron from '../../../components/general/navigation-chevron';

const PaginationWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	min-width: 80px;
	padding-left: 9px;
`;

const PaginationButton = styled.button`
	min-height: 25px;
    min-width: 25px;
    border: none;
    background-color: white;
    margin: 0 10px;
`;

const CurrentFilterLabel = styled.span`
	color: #42affa;
`;

const Pagination = ({
                        pagingValue,
                        handlePrevClick,
                        handleNextClick,
                        handleCurrentClick,
                    }) => (
    <PaginationWrapper>
        <PaginationButton onClick={handlePrevClick}><Chevron rotate={-135} color={`#000`}
                                                             hoverColor={`#439dd5`}/></PaginationButton>

        <PaginationButton
            onClick={handleCurrentClick}><CurrentFilterLabel>{pagingValue}</CurrentFilterLabel></PaginationButton>

        <PaginationButton onClick={handleNextClick}><Chevron color={`#000`} hoverColor={`#439dd5`}/></PaginationButton>
    </PaginationWrapper>
);

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/dashboard/bar/pagination.js